import './Careers.css';

const Careers = () => {
    return (
        <div className="careers-page">
            <div className="careers-container">
                <h1>Careers</h1>
                <p>Join our team and be part of the Renz Foods family!</p>
                {/* Add more content as needed */}
            </div>
        </div>
    );
};

export default Careers;